import React, { ButtonHTMLAttributes } from 'react'

import classnames from 'classnames'

import styles from './styles.module.scss'
import { BeatLoader } from 'react-spinners'

type Colors = 'primary' | 'secondary'
type Sizes = 'sm' | 'md' | 'lg'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: Colors
  size?: Sizes
  loading?: boolean
  fill?: 'outline' | 'filled'
  type: 'reset' | 'button' | 'submit'
}

type ButtonTransformProps = ButtonProps

export const Button = ({
  color,
  size,
  className,
  children,
  loading,
  fill,
  ...rest
}: ButtonTransformProps) => {
  const colors = {
    primary: styles.primary,
    secondary: styles.secondary,
    transparent: styles.transparent
  }

  const sizes = {
    sm: styles.sm,
    md: styles.md,
    lg: styles.lg
  }

  const fills = {
    outline: styles.outline,
    filled: styles.filled
  }

  return (
    <button
      className={classnames(
        styles.btn,
        styles.primary,
        colors[color || 'primary'],
        sizes[size || 'md'],
        fills[fill || 'filled'],
        className
      )}
      disabled={loading}
      {...rest}
    >
      {loading ? <BeatLoader color="#FFF" size="10" /> : children}
    </button>
  )
}
